(ns frontend.ux-overhaul.page-components.navigation.account-dropdown-v2
  (:require-macros [frontend.macros :refer [without-default-action]])
  (:require
   [common.entity :as entity]
   [common.localization :as loc]
   [frontend.account :as account]
   [frontend.page-components.events :as events]
   [frontend.state.current-session :as session]
   [frontend.ux-overhaul.page-components.navigation.events :as rf-events]
   [re-frame.core :as rf]
   [ui.components.radix-ui.avatar.view :as avatar]
   [ui.components.radix-ui.popover.view :as popover]
   [ui.util :as uu]))

(defn dropdown
  [dropdown-state is-guest? _new-navbar-layout?]
  (let [account @session/account
        sandbox? (and (not is-guest?)
                      (:tenant/has-sandbox? @session/tenant)
                      (not (:tenant/sandbox-disabled? @session/tenant))
                      (or (:tenant/sandbox? @session/tenant)
                          (not (->> @session/account-preferences
                                    :disabled-sandbox))))
        account-email (:account/email account)
        username (concat (:account/first-name account) " " (:account/last-name account))]
    [:div
     {:id    "navbar-avatar-container"
      :class (uu/cm "d-lg-block navbar-dropdown-2023"
                    (case @session/role
                      :role/sys-admin "role-SYS-ADMIN"
                      :role/zadmin "role-ZADMIN"
                      :role/admin "role-TA"
                      :role/user "role-TU"
                      :role/guest-buy-side "role-BSG"
                      :role/guest-sell-side "role-SSG"
                      "role-UNKNOWN"))}

     [popover/view
      {:dom-id         "global-navbar-account-dropdown"
       :open?          (:dropdown-status/account? @dropdown-state)
       :positions      ["left"]
       :on-open-change (fn [_]
                         (swap! dropdown-state assoc :dropdown-status/account? (not (:dropdown-status/account? @dropdown-state))))}
      [avatar/view
       {:image-url (:account/picture-url account)
        :fallback  (entity/get-initials account)
        :size      :small
        :font-size :small
        :dom-id    "navbar-avatar"}]
      [:div
       {:class "flex flex-col gap-2"}
       [:div {:class "text-base-light-text bg-base-light"}
        [:div {:class "flex items-center gap-2"}
         [:div
          [avatar/view
           {:dom-id    "navbar-user-avatar-profile"
            :image-url (:account/picture-url account)
            :fallback  (entity/get-initials account)
            :size      :medium
            :font-size :medium}]]
         [:div {:class "flex flex-col gap-1"}
          [:div {:class "font-bold"} username]
          [:div {:class "text-xs text-base-light-text-paler"} account-email]]]]
       (when (not (session/is-guest?))
         [:<>
          [:div
           [:span {:class "block border-solid border-t border-base-light-border-paler"}]]
          [:div
           {:class    "py-1"
            :on-click #(rf/dispatch [::rf-events/navigate-to {:path [:personal-profile :tab-key :my-details]}])}
           [:button
            {:id    "my-profile-and-settings"
             :class "text-base-light-text hover:text-base-light-text-accent"}
            "My profile and settings"]]
          (when (session/dev?)
            [:<>
             [:div
              [:span {:class "block border-solid border-t border-base-light-border-paler"}]]
             [:div
              {:class    "py-1"
               :on-click #(rf/dispatch [::rf-events/navigate-to
                                        {:path [:test]}])}
              [:button
               {:id    "go-to-test-page"
                :class "text-base-light-text hover:text-base-light-text-accent"}
               (loc/tr :go-to-test-page)]]])])

       (when sandbox?
         [:div
          {:class    "py-1"
           :on-click events/toggle-sandbox!}
          [:button
           {:class "text-base-light-text hover:text-base-light-text-accent"}
           (loc/tr (if (:tenant/sandbox? @session/tenant)
                     :switch-to-real-tenant
                     :switch-to-sandbox-tenant))]])

       (when (and (= @session/role :role/guest-sell-side)
                  (not= (->> @session/tenant
                             :tenant/product-plan
                             :features
                             :feature/kpi-reporting
                             :status)
                        :not-in-use))
         [:div
          {:class    "py-1"
           :on-click #(rf/dispatch [::rf-events/navigate-to {:path :guest-kpi-reports}])}
          [:button
           {:class "text-base-light-text hover:text-base-light-text-accent"}
           (loc/tr :reporting)]])

       (when (= @session/role :role/guest-sell-side)
         [:div
          {:class    "py-1"
           :on-click #(rf/dispatch [::rf-events/navigate-to {:path :company-guest}])}
          [:button
           {:class "text-base-light-text hover:text-base-light-text-accent"}
           (loc/tr :company-details)]])

       (when (and (session/zadmin?)
                  (not (session/is-mobile?)))
         [:div
          {:class    "py-1"
           :on-click #(rf/dispatch [::rf-events/navigate-to {:path :settings-tenants}])}
          [:button
           {:class "text-base-light-text hover:text-base-light-text-accent"}
           (loc/tr :navbar-menu/zadmin-settings)]])

       [:div
        [:span {:class "block border-solid border-t border-base-light-border-paler"}]]
       [:div
        {:class    "text-center"
         :on-click (without-default-action
                    (account/reset-session))}
        [:button
         {:id    "account-dropdown-sign-out"
          :class "py-2 w-full text-base-light-text bg-base-light hover:bg-base-regular rounded"}
         (loc/tr :sign-out)]]]]]))
